export default "__VITE_ASSET___Y4m5z5A__"